import { createAppStore } from '@store/createAppStore';

import { ClaimStoreType } from './types';

const [claimDataStore, setClaimDataStore] = createAppStore<ClaimStoreType>(
  {
    isLoading: false,
    claimDetails: null,
  },
  'claimDataStore',
);

export { claimDataStore, setClaimDataStore };
